module.exports = require('./lib/index').default;
module.exports.format = require('./lib/index').format;
module.exports.months = require('./lib/index').months;
module.exports.days = require('./lib/index').days;
